import { useQuery } from '@tanstack/react-query'
import analytics from '@/shared-utils/analytics'
import type {
  AbandonedSelection,
  SearchProductList
} from '@/components/TripActivity/types'
import fetchAbandonedSelections from '@/shared-utils/fetchAbandonedSelections'
import useSeti from '@/hooks/useSeti'
import { getFirstValidAbandonedSelection } from '../utils'

export default function useAbandonedSelections(
  cguid: string,
  appName: string,
  appVersion: string,
  signedIn: boolean,
  productType: SearchProductList
) {
  const includeIsFavorite =
    useSeti('HP_PUWYLO_FAVORITE', false) === 'VARIANT' && signedIn
  const { data = null, error } = useQuery<AbandonedSelection | null>({
    queryKey: [cguid, appName, appVersion, productType, includeIsFavorite],
    queryFn: async () => {
      const selections = await fetchAbandonedSelections(
        cguid,
        appName,
        appVersion,
        productType,
        includeIsFavorite
      )

      return getFirstValidAbandonedSelection(selections)
    },
    staleTime: Infinity,
    enabled: !signedIn
  })

  if (error) {
    analytics.logError({
      message: 'Error thrown from useQuery',
      error: JSON.stringify(error),
      service: 'fetchAbandonedSelections'
    })
  }

  return data
}
